module.exports = __webpack_public_path__ + "img/kogo_GVOV.5cbdda95.png";